export default {"src":"/_next/static/image/public/images/flags/flag_94.856ba1a8d6734b5196f08c7f9dd8920f.svg","height":16,"width":24};